import ConnectionRenderer from 'components/helper/Connection/Renderer';
import { ConnectionRendererPropsType } from 'components/helper/Connection/Renderer';
import { connect } from 'react-redux';
import { getIsOnline } from 'store/connection';

const mapStateToProps = (state): { online: boolean } => ({
	online: getIsOnline(state),
});

export default connect<{ online: boolean }, any, Partial<ConnectionRendererPropsType>>(mapStateToProps)(
	ConnectionRenderer as any
);
